var _defs, _path, _path2, _g, _path3, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    zoomAndPan: "magnify",
    viewBox: "0 0 36.75 23.999999",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "181e280a89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 0.347656 L 20 0.347656 L 20 4 L 16 4 Z M 16 0.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "604b155fb4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.546875 4 L 3 4 L 3 7 L 0.546875 7 Z M 0.546875 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cbbd1856b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33 4 L 35.796875 4 L 35.796875 7 L 33 7 Z M 33 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4231b9f7de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 22 L 30 22 L 30 23.917969 L 7 23.917969 Z M 7 22 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 34.097656 7.269531 L 28.644531 13.933594 C 28.144531 14.566406 27.152344 14.285156 27.042969 13.480469 L 26.042969 5.996094 C 26.03125 5.90625 25.910156 5.890625 25.875 5.976562 L 23 13.09375 C 22.679688 13.886719 21.566406 13.84375 21.304688 13.027344 L 18.421875 4.03125 C 18.390625 3.933594 18.117188 3.933594 18.085938 4.03125 L 15.203125 13.027344 C 14.941406 13.84375 13.832031 13.886719 13.511719 13.09375 L 10.632812 5.976562 C 10.597656 5.890625 10.480469 5.90625 10.46875 5.996094 L 9.464844 13.480469 C 9.355469 14.285156 8.363281 14.566406 7.867188 13.933594 L 2.410156 7.269531 C 2.347656 7.191406 2.226562 7.261719 2.261719 7.355469 L 7.242188 21.160156 L 29.265625 21.160156 L 34.246094 7.355469 C 34.28125 7.261719 34.160156 7.191406 34.097656 7.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 26.109375 5.394531 C 26.761719 5.394531 27.289062 4.851562 27.289062 4.1875 C 27.289062 3.519531 26.761719 2.976562 26.109375 2.976562 C 25.457031 2.976562 24.929688 3.519531 24.929688 4.1875 C 24.929688 4.851562 25.457031 5.394531 26.109375 5.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#181e280a89)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 18.253906 3.289062 C 19.039062 3.289062 19.675781 2.636719 19.675781 1.832031 C 19.675781 1.027344 19.039062 0.375 18.253906 0.375 C 17.46875 0.375 16.832031 1.027344 16.832031 1.832031 C 16.832031 2.636719 17.46875 3.289062 18.253906 3.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 10.398438 5.394531 C 11.050781 5.394531 11.578125 4.851562 11.578125 4.1875 C 11.578125 3.519531 11.050781 2.976562 10.398438 2.976562 C 9.746094 2.976562 9.21875 3.519531 9.21875 4.1875 C 9.21875 4.851562 9.746094 5.394531 10.398438 5.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#604b155fb4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 2.382812 5.808594 C 2.382812 5.289062 1.972656 4.867188 1.464844 4.867188 C 0.960938 4.867188 0.546875 5.289062 0.546875 5.808594 C 0.546875 6.324219 0.960938 6.746094 1.464844 6.746094 C 1.972656 6.746094 2.382812 6.324219 2.382812 5.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cbbd1856b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 35.800781 5.808594 C 35.800781 5.289062 35.390625 4.867188 34.882812 4.867188 C 34.375 4.867188 33.964844 5.289062 33.964844 5.808594 C 33.964844 6.324219 34.375 6.746094 34.882812 6.746094 C 35.390625 6.746094 35.800781 6.324219 35.800781 5.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4231b9f7de)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf46",
    d: "M 29.265625 24.320312 L 7.242188 24.320312 L 7.242188 22.152344 L 29.265625 22.152344 L 29.265625 24.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown_icon.61ea3ec98c0cfd77e191544739c08d15.svg";
export { ForwardRef as ReactComponent };